import CitiesPage from './CitiesPage';

export default CitiesPage;
